'use strict';

angular.module('atex.art').directive('autocloseNavbar',
  function() {
    return {
      scope: false,

      link: function(scope, element, attrs) {
        element.on('click', 'a', function(event) {
          if (!$(event.target).hasClass('dropdown-toggle') && !$(event.target).parents('.dropdown-toggle').length && !$('.navbar-toggle').hasClass('collapsed')) {
            $('.act-navbar-collapse').collapse('hide');
          }
        });
      }
    };
  }
);
